import type { Selection } from "@ui/components/ImagePicker";

export type CoverPreference = "auto" | "swoosh";

/** The cover picker tile to preselect, mirroring how the cover resolves server-side. */
export function selectionFromCover(
  coverPreference: CoverPreference,
  hasCustom: boolean,
  mapAvailable: boolean,
): Selection {
  if (hasCustom) return { type: "upload" };
  if (coverPreference === "auto" && mapAvailable) return { type: "preset", key: "map" };
  return { type: "default" };
}
